import {
  Ship, Globe2, Truck, ShieldCheck, Landmark,
} from "lucide-react";

export const SERVICES = [
  {
    icon: Ship,
    title: "Import & Export",
    desc: "End-to-end coordination of cross-border commodity trade including documentation and execution.",
  },
  {
    icon: Globe2,
    title: "Global Sourcing",
    desc: "Connecting verified suppliers and buyers across petrochemicals, food, metals, and minerals.",
  },
  {
    icon: Truck,
    title: "Logistics Support",
    desc: "Freight coordination, shipping management, and delivery planning through trusted partners.",
  },
  {
    icon: ShieldCheck,
    title: "Risk Management",
    desc: "Ensuring reliability through supplier verification, documentation discipline, and transaction control.",
  },
  {
    icon: Landmark,
    title: "Trade Financing Support",
    desc: "Assisting in structuring transactions through financial coordination when required.",
  },
];
